<template>
    <div class="col-md-12 px-0 py-0">
        <div>
            <div class="row">
                <div class="col-md-5">
                    <button
                        type="button"
                        @click="showBody(0)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 0 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Lista
                    </button>
                    <button
                        type="button"
                        @click="showCreate()"
                        :class="[
                            'btn btn-outline-primary',
                            page == 1 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Agregar
                    </button>
                    <button
                        type="button"
                        @click="showBody(3)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 3 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Ordenar
                    </button>
                    <button
                        type="button"
                        @click="showBody(4)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 4 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Sección ¿Qué es?
                    </button>
                </div>
                <div class="col-md-7 text-right align-top text-success">
                    <span style="font-size: 20px">Jurados</span>
                </div>
            </div>

            <div>
                <contest-judge-list-component
                    v-if="page == 0"
                    v-bind:model_id="model_id"
                    @change="callChangeList"
                ></contest-judge-list-component>
                <contest-judge-form-component
                    v-if="page == 1"
                    v-bind:parent_id="model_id"
                    v-bind:model_id="contest_judge_id"
                    @change="callChangeCreate"
                    :key="componentKey"
                ></contest-judge-form-component>
                <contest-judge-form-component
                    v-if="page == 2"
                    v-bind:parent_id="model_id"
                    v-bind:model_id="contest_judge_id"
                ></contest-judge-form-component>
                <contest-judge-order-component
                    v-if="page == 3"
                    v-bind:model_id="model_id"
                ></contest-judge-order-component>
                <contest-judge-section-component
                    v-if="page == 4"
                    v-bind:model_id="model_id"
                ></contest-judge-section-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            page: 0,
            contest_judge_id: 0,
            componentKey: 1,
        };
    },
    methods: {
        showCreate() {
            this.contest_judge_id = 0;
            this.page = 1;
            this.componentKey += 1;
        },
        showBody(value) {
            this.page = value;
            this.contest_judge_id = 0;
        },
        callChangeCreate() {
            this.page = 0;
            this.contest_judge_id = 0;
        },
        callChangeList(id) {
            this.contest_judge_id = id;
            this.page = 2;
        },
    },
    mounted() {},
};
</script>
